import { Button, Table } from "reactstrap";
import { usePartRefreshQueue } from "../../context/PartRefreshQueueContext";
import "./partRefreshDock.css";

const statusLabel = (item) => {
  if (item.status === "success") {
    return "Success";
  }
  if (item.status === "failed") {
    return item.message || "Failed to fetch";
  }
  if (item.status === "syncing") {
    return "Refreshing…";
  }
  return "Queued";
};

const PartRefreshQueueDock = () => {
  const {
    items,
    panelOpen,
    setPanelOpen,
    isRunning,
    retryFailed,
    clearFinished,
  } = usePartRefreshQueue();

  if (!items.length) {
    return null;
  }

  const pendingCount = items.filter(
    (item) => item.status === "pending" || item.status === "syncing",
  ).length;
  const successCount = items.filter((item) => item.status === "success").length;
  const failedCount = items.filter((item) => item.status === "failed").length;
  const activeItems = items.slice(-12).reverse();

  return (
    <div className="part-refresh-dock">
      <button
        type="button"
        className="part-refresh-dock__toggle"
        onClick={() => setPanelOpen(!panelOpen)}
      >
        <i className={`fa fa-refresh${isRunning ? " fa-spin" : ""}`} />
        {isRunning
          ? ` Refreshing DigiKey · ${pendingCount} remaining`
          : ` DigiKey refresh · ${successCount} done${
              failedCount ? ` · ${failedCount} failed` : ""
            }`}
      </button>
      {panelOpen ? (
        <div className="part-refresh-dock__panel">
          <div className="part-refresh-dock__header">
            <strong>DigiKey refresh queue</strong>
            <span className="text-muted small">
              Continues if you change pages
            </span>
          </div>
          <div className="part-refresh-dock__body">
            <Table className="table-sm mb-0 part-refresh-dock__table">
              <thead>
                <tr>
                  <th>MPN</th>
                  <th>Progress</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {activeItems.map((item) => (
                  <tr key={item.id} className={`is-${item.status}`}>
                    <td>
                      <strong>{item.partNumber}</strong>
                      {item.manufacturer ? (
                        <div className="text-muted small">{item.manufacturer}</div>
                      ) : null}
                    </td>
                    <td>
                      <div className="part-refresh-progress">
                        <div
                          className={`part-refresh-progress__bar is-${item.status}`}
                          style={{ width: `${item.progress || 0}%` }}
                        />
                      </div>
                      <div className="small text-muted">{item.progress || 0}%</div>
                    </td>
                    <td>
                      <span className={`part-refresh-status is-${item.status}`}>
                        {statusLabel(item)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="part-refresh-dock__footer">
            <Button
              type="button"
              color="secondary"
              size="sm"
              onClick={() => setPanelOpen(false)}
            >
              Hide
            </Button>
            {failedCount > 0 ? (
              <Button
                type="button"
                color="primary"
                size="sm"
                disabled={isRunning}
                onClick={retryFailed}
              >
                Retry failed
              </Button>
            ) : null}
            {!isRunning ? (
              <Button
                type="button"
                color="link"
                size="sm"
                onClick={clearFinished}
              >
                Clear
              </Button>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PartRefreshQueueDock;
